<div class="cpcontent">
    <h2>Where am I?</h2>
    <button (click)="getLocation()">Click here</button> 
    <span *ngIf="showTip == true"> Now click on any location on the map.</span>
    <div id="map" #map style="width:100%;height:400px"></div>
</div>
